import {createContext} from 'react';
import {FilterConfigSections, FilterSelectionSections, FilterSliceKeyType} from '@lib/utils';

export type FilterSelectionSlice = {[sliceKey in FilterSliceKeyType]?: FilterSelectionSections};
export type FilterConfigSlice = {[sliceKey in FilterSliceKeyType]?: FilterConfigSections};
export type FilterCacheKeySlice = {[sliceKey in FilterSliceKeyType]?: string};

type FiltersContextProps = {
  configSlices: FilterConfigSlice;
  setConfigSlice: (sliceId: FilterSliceKeyType, config: FilterConfigSections) => void;
  selectionSlices: FilterSelectionSlice;
  setSelectionSlice: (sliceId: FilterSliceKeyType, newSlice: FilterSelectionSections) => void;
  getInitFilterSelection: (config: FilterConfigSections) => FilterSelectionSections;
  cacheKeySlices: FilterCacheKeySlice;
  setCacheKeySlice: (sliceId: FilterSliceKeyType, newCacheKey: string, resetSelection: FilterSelectionSections) => void;
};

export const FiltersContext = createContext<FiltersContextProps>({
  configSlices: {},
  setConfigSlice: (_sliceId: FilterSliceKeyType, _config: FilterConfigSections) => {},
  selectionSlices: {},
  setSelectionSlice: (_sliceId: FilterSliceKeyType, _newSlice?: FilterSelectionSections) => {},
  getInitFilterSelection: (_config: FilterConfigSections) => ({}),
  cacheKeySlices: {},
  setCacheKeySlice: (
    _sliceId: FilterSliceKeyType,
    _newCacheKey: string,
    _resetSelection: FilterSelectionSections,
  ) => {},
});
